<html>

<head>
  <title>Peak Rapor</title>
</head>

<body id="parentdiv">
  <div class="main-title mb-3">
    <div class="print-process-button">
      <div class="row">
        <div class="col-3">
          <label class="container-checkbox">
            <span>Yeni Sayfa</span>
            <input autocomplete="off" type="checkbox" id="txt_form_AddUser_UserIsActive" name="UserIsActive"
                class="form-check-input" [(ngModel)]="isNewPage">
            <span class="checkmark"></span>
        </label>
        </div>
        <div class="col-8">
          <!-- <button class="btn tablo-new-button btn-process" (click)="htmltoPDF()">pdf</button> -->
          <button class="btn tablo-new-button btn-process" (click)="print()">Yazdır</button>
          <!-- <button class="btn tablo-new-button btn-process" (click)="isVisibleDescriptionModal = true">Yeni</button> -->
          <button class="btn tablo-new-button btn-process" style="width: auto;" (click)="isVisibleDescriptionModal = true">Yeni Yorum</button>
          <button class="btn tablo-new-button btn-process" style="width: auto;" (click)="showCreateExcel()">Yeni Tablo</button>
          <button class="btn tablo-new-button btn-process" style="width: auto;" (click)="addExcelTemplate()">Şablonu Kaydet</button>
        </div>
        <div class="col-1">
        </div>
      </div>
    </div>
  </div>
  <div class="A4">
    <div class="header">
      <div class="header-title">
        <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
      </div>
    </div>
    <div class="content content-body">
      <div class="content">
        <img class="peak-img" src="../../../../assets/img/peak_bigimage.png">
      </div>
      <div class="content content-company">
        <img style="width: 25%;" [src]="studentModel.CompanyPhoto | companyPhoto">
      </div>
      <div class="content content-company">
        <h4>{{studentModel.CompanyName}}</h4>
        <h5>{{trainingModel.FullName}}</h5>
        <h5>{{getDateOnlyString(trainingModel.TrainingStartDate)}}</h5>
        <h5>{{trainingModel.TrainingName}}</h5>
      </div>
      <div class="content content-company" style="margin-top: 6rem;">
        <h5>{{studentModel.FirstName + ' ' + studentModel.LastName}}</h5>
        <h6>{{studentModel.TCIdentityNumber}}</h6>
        <h6>{{studentModel.StudentDepartment}}</h6>
      </div>
    </div>
    <div class="footer">
      <div class="footer-title">
        <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
      </div>
    </div>
  </div>
  <div class="A4" *ngIf="isNewPage">
    <div class="header">
      <div class="header-title">
        <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
      </div>
    </div>
    <div class="content content-body">
      <div class="print-page" *ngFor="let item of reportDescription" >
        <div class="print-title action-click" (click)="showUpdateModal(item.id)">
          <h5>{{item.title}}</h5>
        </div>
        <div class="print-desc" style="margin: 10px 40px 0px 40px;">
          <div [innerHTML]="item.description | trustHtml"></div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-title">
        <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
      </div>
    </div>
  </div>
  <ng-container *ngIf="ticariZekaAll != null">
    <ng-container *ngFor="let item of ticariZekaAll[0]; let i = index;let last1 = last">
      <div class="A4" *ngIf="i%2 == 0">
        <div class="header">
          <div class="header-title">
            <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
          </div>
        </div>
        <div class="content content-body">
          <div class="print-page action-click mb-4" *ngFor="let allTest of ticariZekaAll[0]; let j = index;let last = last;"
            (click)="showUpdateExcel(allTest.id)">
            <ng-container *ngIf="j == i || j == i+1">
              <div class="print-title">
                <h5>{{allTest.Title}}</h5>
              </div>
              <div class="print-desc">
                <span>{{allTest.Description}}</span>
                <div>
                  <table>
                    <tr>
                      <th style="width: 50%;">{{allTest.Title}}</th>
                      <th style="width: 10%;">Gözlemlenmedi</th>
                      <th style="width: 10%;">Az</th>
                      <th style="width: 10%;">Yeterli</th>
                      <th style="width: 10%;">Çok İyi</th>
                      <th style="width: 10%;">Mükemmel</th>
                    </tr>
                    <tr class="table-col" *ngFor="let item of allTest.Question">
                      <td>{{item.QuestionTitle}}</td>
                      <td class="action-check"
                        [ngStyle]="item.Answer[0].IsAnswer == true && { 'background-color': '#4caf50','color':'white' }"
                        (click)="$event.stopPropagation();tableCheck(allTest.id,item.QuestionID,item.Answer[0].AnswerID)">{{item.Answer[0].AnswerID}}
                      </td>
                      <td class="action-check"
                        [ngStyle]="item.Answer[1].IsAnswer == true && { 'background-color': '#4caf50','color':'white' }"
                        (click)="$event.stopPropagation();tableCheck(allTest.id,item.QuestionID,item.Answer[1].AnswerID)">{{item.Answer[1].AnswerID}}
                      </td>
                      <td class="action-check"
                        [ngStyle]="item.Answer[2].IsAnswer == true && { 'background-color': '#4caf50','color':'white' }"
                        (click)="$event.stopPropagation();tableCheck(allTest.id,item.QuestionID,item.Answer[2].AnswerID)">{{item.Answer[2].AnswerID}}
                      </td>
                      <td class="action-check"
                        [ngStyle]="item.Answer[3].IsAnswer == true && { 'background-color': '#4caf50','color':'white' }"
                        (click)="$event.stopPropagation();tableCheck(allTest.id,item.QuestionID,item.Answer[3].AnswerID)">{{item.Answer[3].AnswerID}}
                      </td>
                      <td class="action-check"
                        [ngStyle]="item.Answer[4].IsAnswer == true && { 'background-color': '#4caf50','color':'white' }"
                        (click)="$event.stopPropagation();tableCheck(allTest.id,item.QuestionID,item.Answer[4].AnswerID)">{{item.Answer[4].AnswerID}}
                      </td>
                    </tr>
                    <tr>
                    <tr>
                      <th>Toplam</th>
                      <th>{{allTest.Calculate1}}</th>
                      <th>{{allTest.Calculate2}}</th>
                      <th>{{allTest.Calculate3}}</th>
                      <th>{{allTest.Calculate4}}</th>
                      <th>{{allTest.Calculate5}}</th>
                    </tr>
                  </table>
                </div>
    
              </div>
            </ng-container>
            <ng-container *ngIf="(j == i || j == i+1) && last && (j%2 ==0)">
              <div class="print-title mt-4">
                <h5>Değerlendirme Özeti</h5>
              </div>
              <div class="print-desc">
                <span>Belirtilen yetkinlikler özelinde katılımcının bu yetkinliklere ilişkin davranış göstergelerini ne derece ortaya koyduğunu gösterir. 
                  Her bir yetkinlik için belirlenen ağırlık toplam içerisindeki önceliğini belirtir.</span>
                <div>
                  <table>
                    <tr>
                      <th style="width: 50%;">Yetkinlik</th>
                      <th style="width: 10%;">Ağırlık%</th>
                      <th style="width: 10%;">Değerlendirme</th>
                      <th style="width: 10%;">Ağırlıklı</th>
                    </tr>
                    <tr class="table-col" *ngFor="let sonuc of ticariZekaAll[0]">
                      <td>{{sonuc.Title}}</td>
                      <td class="action-check">{{sonuc.Percent}}</td>
                      <td class="action-check">{{(sonuc.Calculate1 + sonuc.Calculate2 + sonuc.Calculate3 + sonuc.Calculate4 + sonuc.Calculate5)/sonuc.Question.length}}</td>
                      <td class="action-check">{{(sonuc.Percent *((sonuc.Calculate1 + sonuc.Calculate2 + sonuc.Calculate3 + sonuc.Calculate4 + sonuc.Calculate5)/sonuc.Question.length)/100)}}</td>
                    </tr>
                    <tr>
                    <tr>
                      <th>Toplam</th>
                      <th>{{totalPercent}}</th>
                      <th>{{totalDegerlendirme}}</th>
                      <th>{{totalAgirlik}}</th>
                    </tr>
                  </table>
                </div>
      
              </div>
            </ng-container>
          </div>
        </div>
        <div class="footer">
          <div class="footer-title">
            <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
          </div>
        </div>
      </div>
      <div class="A4" *ngIf="i%2 == 1 && last1">
        <div class="header">
          <div class="header-title">
            <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
          </div>
        </div>
        <div class="content content-body">
          <div class="print-page action-click mb-4">
              <div class="print-title mt-4">
                <h5>Değerlendirme Özeti</h5>
              </div>
              <div class="print-desc">
                <span>Belirtilen yetkinlikler özelinde katılımcının bu yetkinliklere ilişkin davranış göstergelerini ne derece ortaya koyduğunu gösterir. 
                  Her bir yetkinlik için belirlenen ağırlık toplam içerisindeki önceliğini belirtir.</span>
                <div>
                  <table>
                    <tr>
                      <th style="width: 50%;">Yetkinlik</th>
                      <th style="width: 10%;">Ağırlık%</th>
                      <th style="width: 10%;">Değerlendirme</th>
                      <th style="width: 10%;">Ağırlıklı</th>
                    </tr>
                    <tr class="table-col" *ngFor="let sonuc of ticariZekaAll[0]">
                      <td>{{sonuc.Title}}</td>
                      <td class="action-check">{{sonuc.Percent}}</td>
                      <td class="action-check">{{(sonuc.Calculate1 + sonuc.Calculate2 + sonuc.Calculate3 + sonuc.Calculate4 + sonuc.Calculate5)/sonuc.Question.length | curruncyFixed}}</td>
                      <td class="action-check">{{(sonuc.Percent *((sonuc.Calculate1 + sonuc.Calculate2 + sonuc.Calculate3 + sonuc.Calculate4 + sonuc.Calculate5)/sonuc.Question.length)/100) | curruncyFixed}}</td>
                    </tr>
                    <tr>
                    <tr>
                      <th>Toplam</th>
                      <th>{{totalPercent}}</th>
                      <th>{{totalDegerlendirme | curruncyFixed}}</th>
                      <th>{{totalAgirlik | curruncyFixed}}</th>
                    </tr>
                  </table>
                </div>
      
              </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-title">
            <img class="print-header-img" src="/assets/img/peak-gelisim-logo.png">
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>    
</body>

</html>

<app-modal [(isVisible)]="isVisibleNewExcelModal">
  <div class="row">
    <div class="col-md-11 center" style="text-align: unset;">
      <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i
          class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Yeni Tablo</h4>

          <form class="needs-validation" name="form" (ngSubmit)="k.form.valid && createNewExcel()" #k="ngForm">

            <div class="row mb-3">
              <div class="col-md-9">
                <label class="form-text">Başlık </label>
                <input class="form-control" name="titleExcel" [(ngModel)]="TitleExcel" autocomplete="off" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                      <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                    </div> -->
              </div>
              <div class="col-md-3">
                <label class="form-text">Ağırlık </label>
                <input class="form-control" name="percent" [(ngModel)]="Percent" autocomplete="off" type="number" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                      <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                    </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Açıklama </label>
                <textarea class="form-control" name="description" [(ngModel)]="DescriptionExcel" autocomplete="off"
                  required></textarea>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Sorular </label>
                <ng-container *ngFor="let item of questions; let i = index">
                  <div class="row mb-2">
                    <div style="width: 90%;padding-left: 15px;">
                      <input class="form-control" name="questionTitle_{{item.questionID}}" [(ngModel)]="item.questionTitle"
                        autocomplete="off" required>
                    </div>
                    <div style="text-align: right;padding-left: 5px;padding-right: 5px; width: 10%;">
                      <!-- <a class="btn btn-circle-sm bgreen" style="margin-right: 5px;" *ngIf="i != 0">
                        <i class="uil uil-plus" aria-hidden="true"></i>
                      </a> -->
                      <a class="btn btn-circle-sm bred" (click)="deleteExcelQuestion(item.questionID)">
                        <i class="uil uil-times" aria-hidden="true"></i></a>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="col-12">
                <a class="btn bgreen question-add-button" (click)="addExcelQuestion()">
                  <i class="uil uil-plus" aria-hidden="true"></i><span>Yeni Soru Ekle</span>
                </a>
              </div>
            </div>
    
            <div class="center tablo-button">
              <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
              <button type="button" class="btn tablo-new tablo-edit-button" (click)="deleteExcel()">Sil</button>
              <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
            </div>
          </form>


    </div>
  </div>
</app-modal>

<app-modal [(isVisible)]="isVisibleExcelUpdateModal">
  <div class="row">
    <div class="col-md-11 center" style="text-align: unset;">
      <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i
          class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Tabloyu Düzenle</h4>

      <form class="needs-validation" name="form" (ngSubmit)="h.form.valid && updateExcelModel()" #h="ngForm">

        <div class="row mb-3">
          <div class="col-md-9">
            <label class="form-text">Başlık </label>
            <input class="form-control" name="titleExcel" [(ngModel)]="TitleExcel" autocomplete="off" required>
            <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
          </div>
          <div class="col-md-3">
            <label class="form-text">Ağırlık </label>
            <input class="form-control" name="percent" [(ngModel)]="Percent" autocomplete="off" type="number" required>
            <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-text">Açıklama </label>
            <textarea class="form-control" name="description" [(ngModel)]="DescriptionExcel" autocomplete="off"
              required></textarea>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-text">Sorular </label>
            <ng-container *ngFor="let item of questions; let i = index">
              <div class="row mb-2">
                <div style="width: 90%;padding-left: 15px;">
                  <input class="form-control" name="questionTitle_{{item.questionID}}" [(ngModel)]="item.questionTitle"
                    autocomplete="off">
                </div>
                <div style="text-align: right;padding-left: 5px;padding-right: 5px; width: 10%;">
                  <!-- <a class="btn btn-circle-sm bgreen" style="margin-right: 5px;" *ngIf="i != 0">
                    <i class="uil uil-plus" aria-hidden="true"></i>
                  </a> -->
                  <a class="btn btn-circle-sm bred" (click)="deleteExcelQuestion(item.questionID)">
                    <i class="uil uil-times" aria-hidden="true"></i></a>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-12">
            <a class="btn bgreen question-add-button" (click)="addExcelQuestion()">
              <i class="uil uil-plus" aria-hidden="true"></i><span>Yeni Soru Ekle</span>
            </a>
          </div>
        </div>

        <div class="center tablo-button">
          <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
          <button type="button" class="btn tablo-new tablo-edit-button" (click)="deleteExcel()">Sil</button>
          <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
        </div>
      </form>


    </div>
  </div>
</app-modal>

<app-modal [(isVisible)]="isVisibleDescriptionModal">
  <div class="row">
      <div class="col-md-11 center" style="text-align: unset;">
          <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Açıklama Ekle</h4>

          <form class="needs-validation" name="form" (ngSubmit)="f.form.valid && createModel()" #f="ngForm">

            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Başlık </label>
                <input class="form-control" name="title" [(ngModel)]="Title" autocomplete="off" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Açıklama </label>
                <ckeditor #editor [config]="EditorConfig" [editor]="Editor" (ready)="onEditorReady($event)" (change)="onEditorChange($event)" 
                    name="AnnouncementDescription" [(ngModel)]="Description"  rows="5" required>
                </ckeditor>
                <!-- <div *ngIf="f.submitted && Description.invalid" class="invalid-feedback">
                  <div *ngIf="Description.errors.required">Lütfen açıklama giriniz.</div>
                </div> -->
              </div>
            </div>

              <div class="center tablo-button">
                  <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
                  <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
              </div>
          </form>


      </div>
  </div>
</app-modal>

<app-modal [(isVisible)]="isVisibleDescriptionUpdateModal">
  <div class="row">
      <div class="col-md-11 center" style="text-align: unset;">
          <h4 class="mb-5 text-center form-text-heading2" style="font-size: 1.5em;margin-bottom: 40px;"><i class="fas fa-user-graduate form-icon-heading" aria-hidden="true"></i>Açıklama Düzenle</h4>

          <form class="needs-validation" name="form" (ngSubmit)="f.form.valid && updateModal()" #g="ngForm">

            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Başlık </label>
                <input class="form-control" name="title" [(ngModel)]="Title" autocomplete="off" required>
                <!-- <div *ngIf="f.submitted && Title.invalid" class="invalid-feedback">
                  <div *ngIf="Title.errors.required">Lütfen başlık giriniz.</div>
                </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="form-text">Açıklama </label>
                <ckeditor #editor [config]="EditorConfig" [editor]="Editor" (ready)="onEditorReady($event)" (change)="onEditorChange($event)" 
                    name="AnnouncementDescription" [(ngModel)]="Description"  rows="5" required>
                </ckeditor>
                <!-- <div *ngIf="f.submitted && Description.invalid" class="invalid-feedback">
                  <div *ngIf="Description.errors.required">Lütfen açıklama giriniz.</div>
                </div> -->
              </div>
            </div>

              <div class="center tablo-button">
                  <button type="button" class="btn tablo-edit-button" (click)="cancel()">Kapat</button>
                  <button type="button" class="btn tablo-new tablo-edit-button" (click)="deleteModal()">Sil</button>
                  <button type="submit" class="btn tablo-new tablo-new-button">Kaydet</button>
              </div>
          </form>


      </div>
  </div>
</app-modal>